module.exports = __webpack_public_path__ + "media/assets/icons/messenger-grey-fd5ca7b42924a9adffe4671d415ae0ce.svg";